import React from 'react';
import { classNameTriskeleParser } from '../../../utilities/customStyles';
import {
  BODY_TEXT_3, Body4400U, Body4500N, CAPTION_TEXT_2, EDIT_ICON, MEASURE_ICON, RESTORE_ICON, TRASH_ICON
} from '../../../utilities/generatedClasses';

const renderQuantity = (rec) => {
  const arr = rec.QtyDescrptr_Qty_UnitIdArray;

  if (arr.length === 1 && !rec.QtyDescrptr_Qty_UnitIdArray_HrMin) {
    return (
      <div className={`recommendation-padding-txt ${Body4400U}`}>
        {arr[0].Qty} {arr[0].Unit}
      </div>
    );
  }

  if (arr.length === 2 && arr[0].QtyDescrptr === 'Hours') {
    return (
      <div className={`recommendation-padding-txt ${Body4400U}`}>
        {arr[0].Qty > 0 && <>{arr[0].Qty}hr</>}
        {arr[1].Qty > 0 && <> {arr[1].Qty}min</>}
      </div>
    );
  }

  if (arr.length === 2 && arr.every(item => item.QtyDescrptr === 'Qty')) {
    return (
      <div className={`recommendation-padding-txt ${Body4400U}`}>
        {arr[0].Qty} {arr[0].Unit}
      </div>
    );
  }

  if (arr.length === 2) {
    return (
      <div className={`recommendation-padding-txt ${Body4400U}`}>
        {arr[0].Qty}-{arr[1].Qty} {arr[0].Unit}
      </div>
    );
  }

  if (arr.length === 4) {
    return (
      <label className={`card_body ${Body4400U}`}>
        sys {arr[0].Qty}-{arr[1].Qty} {arr[0].Unit} dia {arr[2].Qty}-{arr[3].Qty} {arr[2].Unit}
      </label>
    );
  }

  return null;
};

const RecommendationsList = (props) => {
  const {
    addedRecommendations, deleteRecommendation, addOrEditRecommendation, openUserProfile, restoreRecommendation
  } = props;
  return (
    <div>
      {/* <div className={`${Heading6500N} list-of-rec-title`}>List of Recommendations</div> */}
       {(!addedRecommendations || addedRecommendations.length === 0)
                    && <div className={`${BODY_TEXT_3}`} style={{ marginTop: '26px'}}>Measures with Recommendations will appear here</div>
                }
      <div className="list-recommendation-grid">
       
        {addedRecommendations && addedRecommendations.map((recommendation, index) => (
          <div
            key={index}
            className={`recommendation-card_content  ${recommendation.PrcsParmtrValueOne === 'deleted' ? `${classNameTriskeleParser('Filled Card', 'Deleted', 'Card')}` : `${classNameTriskeleParser('Filled Card', recommendation.Category, 'Card')}`}`}
                    >
            <div className="row-flex">
              <div
                className={`MeasureIconList  icon-margin-10px x_large_size ${recommendation.PrcsParmtrValueOne === 'deleted' ? MEASURE_ICON : ''} ${recommendation.iconClassName}`}
                style={{
                  WebkitMaskImage: `${recommendation.icon}`
                }}
               />
              <div className={`${recommendation.PrcsParmtrValueOne === 'deleted' ? 'line-through ' : ''}`}>
                <label className={`${Body4400U} ${recommendation.PrcsParmtrValueOne === 'deleted' ? 'line-through ' : ''}`}>{recommendation.MeasureName}</label>
                <div>{renderQuantity(recommendation)}</div>
                <label className={`ellipsis-dynamic recommendation-padding-txt ${Body4400U} ${recommendation.PrcsParmtrValueOne === 'deleted' ? 'line-through ' : ''}`} style={{ width: 'unset' }}>
                  {recommendation.DayOfWeekFreqcy}
                </label>
                <label className={`card_footer ellipsis-text ${Body4500N}`}>{recommendation.StartDateFormatted} -  {recommendation.EndDateFormatted}</label>
                <label className={`card_footer ellipsis-text ${recommendation.VisualNameTwo ? classNameTriskeleParser(recommendation.VisualNameTwo, recommendation.VisualTypeTwo, 'Text') : CAPTION_TEXT_2}`}><span onClick={() => openUserProfile(recommendation.ProviderId)} className={classNameTriskeleParser('Caption 2', 'Middle Navy', 'Text')}>{recommendation.ProviderName}</span></label>
              </div>
            </div>

            <div className="column-flex space-between mr-10 edit-rec-actions">
              <div
                className={`recommendation-list-icons ${TRASH_ICON}`}
                onClick={() => deleteRecommendation(recommendation)}
                aria-hidden="true"
                style={{ opacity: recommendation.PrcsParmtrValueOne === 'deleted' ? 0 : 1 }} />
              {recommendation.PrcsParmtrValueOne === 'deleted'
                   && (
                   <div
                     className={`recommendation-list-icons ${RESTORE_ICON}`}
                     onClick={() => restoreRecommendation(recommendation)}
                     aria-hidden="true" />
                   )
                }
              {recommendation.PrcsParmtrValueOne !== 'deleted'
                   && (
                   <div
                     className={`recommendation-list-icons ${EDIT_ICON}`}
                     onClick={() => addOrEditRecommendation(null, recommendation)}
                     aria-hidden="true" />
                   )
                }
            </div>

          </div>
        ))}
      </div>
    </div>
  );
};

export default RecommendationsList;
